import axios from 'axios';

import { OfficeJson } from './contentTypes.greenhouse';

export const BOARDS_API_URL = 'https://boards-api.greenhouse.io/v1/boards/clover';

export async function fetchOffices() {
  const { data: { offices = [] } } = await axios.get<{ offices: OfficeJson[] }>(`${BOARDS_API_URL}/offices`);
  return offices;
}
